import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Lock({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'22px'} viewBox={'0 0 20 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M5,12 C4.44771525,12 4,12.4477153 4,13 L4,20 C4,20.5522847 4.44771525,21 5,21 L19,21 C19.5522847,21 20,20.5522847 20,20 L20,13 C20,12.4477153 19.5522847,12 19,12 L5,12 Z M5,10 L19,10 C20.6568542,10 22,11.3431458 22,13 L22,20 C22,21.6568542 20.6568542,23 19,23 L5,23 C3.34314575,23 2,21.6568542 2,20 L2,13 C2,11.3431458 3.34314575,10 5,10 Z M8,11 C8,11.5522847 7.55228475,12 7,12 C6.44771525,12 6,11.5522847 6,11 L6,7 C6,3.6862915 8.6862915,1 12,1 C15.3137085,1 18,3.6862915 18,7 L18,11 C18,11.5522847 17.5522847,12 17,12 C16.4477153,12 16,11.5522847 16,11 L16,7 C16,4.790861 14.209139,3 12,3 C9.790861,3 8,4.790861 8,7 L8,11 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Lock.propTypes = {
  className: PropTypes.string,
}
